export const Logo = ({ size = 36 }) => (
  <svg data-testid="kgs-logo" width={size} height={size} viewBox="0 0 48 48" aria-label="KGS logo">
    <rect width="48" height="48" fill="#FF6B00" />
    <path d="M11 7h8v13.5L29.5 7H39L26.5 22.5 40 41h-9.8L19 28.4V41h-8V7z" fill="#0B0C10" />
    <rect x="11" y="41" width="29" height="2.5" fill="#0B0C10" opacity="0.35" />
  </svg>
);
